import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export function PageHero({ img, eyebrow, title, serif, crumb }) {
    return (
        <section className="relative min-h-[62vh] flex items-end overflow-hidden" data-testid="page-hero">
            <div className="absolute inset-0" aria-hidden="true">
                <img src={img} alt="" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-ink/60" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-ink/70" />
            </div>
            <div className="relative mx-auto w-full max-w-[1400px] px-5 sm:px-8 pb-16 pt-40">
                <Reveal>
                    <p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold mb-4">
                        {crumb ? crumb : eyebrow}
                    </p>
                </Reveal>
                <Reveal delay={0.1}>
                    <h1 className="text-4xl sm:text-6xl font-light tracking-tighter leading-[1.02] text-ivory max-w-4xl">
                        {title} {serif && <span className="font-display italic text-gold">{serif}</span>}
                    </h1>
                </Reveal>
            </div>
        </section>
    );
}

export function CtaBand() {
    return (
        <section className="relative overflow-hidden border-y border-linew bg-coal" data-testid="cta-band">
            <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-20 lg:py-28 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
                <Reveal className="max-w-2xl">
                    <p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold mb-4">
                        Prêt à démarrer ?
                    </p>
                    <h2 className="text-4xl sm:text-5xl font-light tracking-tighter text-ivory leading-[1.05]">
                        Votre devis gratuit sous{" "}
                        <span className="font-display italic text-gold">48 heures.</span>
                    </h2>
                    <p className="mt-5 text-smoke leading-relaxed max-w-xl">
                        Décrivez votre projet en 2 minutes, joignez quelques photos :
                        nous revenons vers vous avec un chiffrage clair, poste par poste.
                    </p>
                </Reveal>
                <Reveal delay={0.12} className="flex flex-col sm:flex-row gap-4 shrink-0">
                    <Link
                        to="/devis"
                        className="inline-flex items-center justify-center rounded-full bg-gold text-ink font-bold px-9 py-4 hover:scale-[1.04] transition-transform duration-300"
                        data-testid="cta-band-devis"
                    >
                        Demander mon devis
                    </Link>
                    <a
                        href="tel:+33650088282"
                        className="inline-flex items-center justify-center rounded-full border border-gold/60 text-gold px-9 py-4 hover:bg-gold/10 transition-colors"
                        data-testid="cta-band-call"
                    >
                        Appeler maintenant
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
